import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import CommentPost from 'flarum/forum/components/CommentPost';
import SettingsPage from 'flarum/forum/components/SettingsPage';
import DiscussionComposer from 'flarum/forum/components/DiscussionComposer';
import ReplyComposer from 'flarum/forum/components/ReplyComposer';
import FieldSet from 'flarum/common/components/FieldSet';

import TranslationPane from './components/TranslationPane';
import LanguageSettings from './components/LanguageSettings';
import SourceLangControl from './components/SourceLangControl';
import ReviewControls from './components/ReviewControls';

/*
 * The reader side of docs/FORUM_I18N_PLAN.md §3 and the composer control of §2.
 *
 * Note what is NOT here: the ladder itself. The server resolves it and sends a
 * single `translation` attribute — which pane to show, in which language, and
 * whether a human vouched for it. Re-deciding that here would mean two
 * implementations of the precedence rules, drifting apart.
 */
app.initializers.add('scoreflection-translate', () => {
  extend(CommentPost.prototype, 'content', function (vdom) {
    const post = this.attrs.post;
    const resolved = post.attribute('translation');
    if (!resolved) return;

    vdom.push(TranslationPane.component({ post, resolved }));
    vdom.push(ReviewControls.component({ post }));
  });

  extend(SettingsPage.prototype, 'settingsItems', function (items) {
    items.add(
      'scoreflection-translate',
      FieldSet.component(
        { label: app.translator.trans('scoreflection-translate.forum.settings.heading') },
        [LanguageSettings.component()]
      ),
      -10
    );
  });

  // Both composers thread their attributes through the same request data, and
  // the server reads `sourceLang` from it in one listener - see
  // SetPostSourceLang, and StartDiscussionHandler passing $data into PostReply.
  [DiscussionComposer, ReplyComposer].forEach((Composer) => {
    extend(Composer.prototype, 'headerItems', function (items) {
      items.add('sourceLang', SourceLangControl.component({ composer: this }), -5);
    });

    extend(Composer.prototype, 'data', function (data) {
      if (this.sourceLang) data.sourceLang = this.sourceLang;
    });
  });
});
